import {
  CheckOutlined,
  ExclamationCircleOutlined,
  ExclamationCircleFilled,
  HourglassOutlined,
  CheckCircleFilled,
  BankOutlined,
  MinusCircleOutlined,
  WarningOutlined,
  StopOutlined,
  LoadingOutlined,
  SyncOutlined,
} from "@ant-design/icons";
export const getIcon = (i) => {
  if (i === "PENDING") {
    return <HourglassOutlined />;
  } else if (i === "expired") {
    return <StopOutlined />;
  } else if (i === "SUCCESS" || i === "success"|| i === "Active") {
    return <CheckOutlined />;
  } else if (i === "REJECTED" || i === "not_found") {
    return <StopOutlined />;
  } else if (i === "PROCESSING") {
    return <HourglassOutlined />;
  } else if (i === "IN_QUEUE") {
    return <LoadingOutlined />;
  } else if (i === "INQ_MANUAL") {
    return <BankOutlined />;
  } else if (i === "ONHOLD") {
    return <WarningOutlined />;
  } else if (i === "VERRIFY_FAILED") {
    return <ExclamationCircleOutlined />;
  } else if (i === "REQUESTING") {
    return <SyncOutlined spin />;
  } else if (i === "FAILED") {
    return <StopOutlined />;
  } else {
    return <MinusCircleOutlined />;
  }
};

export const getAlerIcon = (i) => {
  if (i === "PENDING") {
    return <HourglassOutlined />;
  } else if (i === "expired") {
    return <StopOutlined />;
  } else if (i === "SUCCESS") {
    return <CheckCircleFilled />;
  } else if (i === "REJECTED") {
    return <StopOutlined />;
  } else if (i === "PROCESSING") {
    return <HourglassOutlined />;
  } else if (i === "IN_QUEUE") {
    return <LoadingOutlined />;
  } else if (i === "INQ_MANUAL") {
    return <BankOutlined />;
  } else if (i === "REQUESTING") {
    return <SyncOutlined spin />;
  } else if (i === "VERRIFY_FAILED") {
    return <ExclamationCircleFilled />;
  } else {
    return <MinusCircleOutlined />;
  }
};
